import { useState } from "react";

export function ResetButton({
  pending,
  onReset,
}: {
  pending: boolean;
  onReset: () => void;
}) {
  const [confirming, setConfirming] = useState(false);
  return (
    <div className="pt-4 space-y-2">
      {!confirming ? (
        <button
          type="button"
          onClick={() => setConfirming(true)}
          className="w-full py-2.5 rounded-lg border border-danger/40 text-danger text-sm font-medium hover:bg-danger/10 transition"
        >
          Reset skill profile
        </button>
      ) : (
        <div className="rounded-lg border border-danger/40 bg-danger/5 p-4 space-y-3">
          <p className="text-sm text-text">
            Permanently delete every signal logged about your play? The coach
            starts over. Conversation history is kept.
          </p>
          <div className="flex gap-2">
            <button
              type="button"
              onClick={() => {
                onReset();
                setConfirming(false);
              }}
              disabled={pending}
              className="flex-1 py-2 rounded-lg bg-danger text-white text-sm font-medium hover:bg-danger/90 transition disabled:opacity-50"
            >
              {pending ? "Resetting…" : "Yes, reset"}
            </button>
            <button
              type="button"
              onClick={() => setConfirming(false)}
              className="flex-1 py-2 rounded-lg border border-border text-text text-sm font-medium hover:bg-text/5 transition"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
      <p className="text-xs text-text-muted/70 text-center">
        Clears the coach's read on you. Conversations are kept.
      </p>
    </div>
  );
}
